<template>
    <v-container>
        <v-dialog v-model="dialog" width="600" @click:outside="closeModal" :retain-focus="false">
            <v-card class="custom-card" rounded="0">
                <v-toolbar color="secondary" class="white--text">
                    <v-toolbar-title class="font-weight-bold">
                        Remove Animal(s)
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon class="white--text" @click="closeModal">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="black--text">
                    <v-row class="my-5">
                        <v-col cols="12">
                            Are you sure you want to remove these animals from this group?
                        </v-col>

                    </v-row>

                    <v-divider></v-divider>
                </v-card-text>
                <v-card-actions class="mt-2 pb-3" style="justify-content: center;">
                    <v-btn @click="closeModal" outlined class="mr-2 px-5" right height="44" depressed color="primary">
                        No
                    </v-btn>
                    <v-btn @click="submit" right height="44" color="primary" class="px-5">
                        Yes
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
export default {
    computed: {
        dialog() {
            return this.dialogI;
        },
    },

    methods: {
        closeModal() {
            this.$emit('modal:closed');
        },
        submit() {
            this.$emit('remove:animals');
        },
    },

    props: {
        dialogI: {
            type: Boolean,
            required: true,
        },
    },
}
</script>
  